import React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';
import { useNavigate } from 'react-router-dom';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

function getPayrollTypeLabel(item) {
  if (item?.payrollType === 'MONTHLY') return 'Aylik maas';
  if (item?.payrollType === 'HOURLY') return 'Saatlik ucret';
  if (item?.payrollType === 'PERCENTAGE') return 'Yuzdelik model';
  return 'Tanimsiz model';
}

function StaffPayrollRow({ item, onCalculate }) {
  return (
    <MDBox
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.25,
        p: 1.25,
        borderRadius: '14px',
        border: '1px solid rgba(0,0,0,0.08)',
        '&:not(:last-child)': {
          mb: 1,
        },
        flexWrap: 'wrap',
      }}
    >
      <MDBox sx={{ minWidth: 180, flex: '1 1 220px' }}>
        <MDTypography variant="button" fontWeight="bold">
          {item.staffName || 'Personel'}
        </MDTypography>

        <MDTypography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
          {item.email || item.phone || 'Iletisim bilgisi yok'}
        </MDTypography>
      </MDBox>

      <Chip
        size="small"
        label={getPayrollTypeLabel(item)}
        sx={{ borderRadius: '999px', fontWeight: 700 }}
      />

      <MDBox sx={{ minWidth: 160 }}>
        <MDTypography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
          Ucret modeli
        </MDTypography>

        <MDTypography variant="button" fontWeight="bold">
          {item.payrollLabel || '-'}
        </MDTypography>
      </MDBox>

      <Button
        variant="contained"
        startIcon={<Icon>calculate</Icon>}
        onClick={() => onCalculate?.(item)}
        sx={{
          borderRadius: '999px',
          textTransform: 'none',
          fontWeight: 800,
          boxShadow: 'none',
          color: '#fff !important',
        }}
      >
        Maas hesapla
      </Button>
    </MDBox>
  );
}

export default function AccountingPayrollTab({ data }) {
  const navigate = useNavigate();
  const rows = Array.isArray(data?.rows) ? data.rows : [];

  const handleCalculatePayroll = React.useCallback(
    (staff) => {
      if (!staff?.staffId) return;
      navigate(`/app/pilates/accounting/payroll/${staff.staffId}`);
    },
    [navigate]
  );

  return (
    <MDBox>
      <MDBox sx={{ mb: 1.5 }}>
        <MDTypography variant="h6" fontWeight="bold">
          Maaslar
        </MDTypography>
        <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
          Maasa dahil personeli goruntule ve tek tikla maas hesabina gec.
        </MDTypography>
      </MDBox>

      <Card
        sx={{
          borderRadius: '18px',
          border: '1px solid rgba(0,0,0,0.08)',
          boxShadow: 'none',
          overflow: 'hidden',
        }}
      >
        <MDBox
          sx={{
            px: 1.5,
            py: 1.25,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 1,
            flexWrap: 'wrap',
          }}
        >
          <MDBox>
            <MDTypography variant="button" fontWeight="bold">
              Maas Hesabina Hazir Personel
            </MDTypography>

            <MDTypography variant="caption" sx={{ color: 'text.secondary', display: 'block' }}>
              Aktif ve maasa dahil personel listesi
            </MDTypography>
          </MDBox>

          <Chip
            size="small"
            label={`${rows.length} kisi`}
            sx={{ borderRadius: '999px', fontWeight: 800 }}
          />
        </MDBox>

        <Divider />

        <MDBox sx={{ p: 1.5 }}>
          {!rows.length ? (
            <Alert severity="info">Maasa dahil personel bulunamadi.</Alert>
          ) : (
            <MDBox>
              {rows.map((item) => (
                <StaffPayrollRow
                  key={item.staffId}
                  item={item}
                  onCalculate={handleCalculatePayroll}
                />
              ))}
            </MDBox>
          )}
        </MDBox>
      </Card>
    </MDBox>
  );
}
